import React from 'react';
import Image from '../../../components/AppImage';

import GradeCell from './GradeCell';
import { StudentGradeRow as StudentGradeRowType, Assignment, GradeEntry } from '../types';

interface StudentGradeRowProps {
  studentRow: StudentGradeRowType;
  assignments: Assignment[];
  onGradeChange: (studentId: string, assignmentId: string, grade: Partial<GradeEntry>) => void;
  onShowGradeDetails: (studentId: string, assignmentId: string) => void;
  onStudentClick: (studentId: string) => void;
}

const StudentGradeRow = ({
  studentRow,
  assignments,
  onGradeChange,
  onShowGradeDetails,
  onStudentClick,
}: StudentGradeRowProps) => {
  const { student, grades, average, overallQualification } = studentRow;

  const getAverageColor = () => {
    if (overallQualification) {
      if (overallQualification === 'FB') return 'text-success';
      if (overallQualification === 'B') return 'text-primary';
      if (overallQualification === 'S') return 'text-warning';
      return 'text-error';
    }

    if (average !== undefined) {
      if (average >= 9) return 'text-success';
      if (average >= 7) return 'text-primary';
      if (average >= 5) return 'text-warning';
      return 'text-error';
    }

    return 'text-muted-foreground';
  };

  return (
    <div className="flex items-center border-b border-border hover:bg-muted/50 transition-colors duration-150">
      <div
        className="sticky left-0 z-10 bg-card border-r border-border p-4 cursor-pointer hover:bg-muted transition-colors duration-150"
        style={{ minWidth: '250px' }}
        onClick={() => onStudentClick(student.id)}
      >
        <div className="flex items-center gap-3">
          <div className="relative flex-shrink-0">
            <Image
              src={student.avatar}
              alt={`Poză de profil: ${student.name}`}
              className="w-10 h-10 rounded-full object-cover"
            />
            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-success rounded-full border-2 border-card" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground truncate">{student.name}</p>
            <p className="text-xs text-muted-foreground">{student.studentId}</p>
          </div>
        </div>
      </div>

      <div className="flex items-center flex-1 overflow-x-auto">
        {assignments.map((assignment) => (
          <div
            key={assignment.id}
            className="flex-shrink-0 p-2"
            style={{ minWidth: '120px' }}
          >
            <GradeCell
              grade={grades.get(assignment.id)}
              assignment={assignment}
              educationLevel={student.educationLevel}
              onGradeChange={(grade) =>
                onGradeChange(student.id, assignment.id, grade)
              }
              onShowDetails={() => onShowGradeDetails(student.id, assignment.id)}
            />
          </div>
        ))}
      </div>

      <div
        className="sticky right-0 z-10 bg-card border-l border-border p-4"
        style={{ minWidth: '120px' }}
      >
        <div className="text-center">
          <p className={`text-lg font-semibold ${getAverageColor()}`}>
            {overallQualification || (average !== undefined ? average.toFixed(2) : '-')}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Medie</p>
        </div>
      </div>
    </div>
  );
};

export default StudentGradeRow;
